import(/* webpackMode: "eager", webpackExports: ["PublicAuthorProfilePanel"] */ "/workspace/src/components/public/author-panels.tsx");
